import React, { useState, useEffect } from 'react';
import { Box, Flex, Text, useColorModeValue } from '@chakra-ui/react';
import Chart from 'react-apexcharts';
import Card from 'components/card/Card.js';
import { gpIDsLineBarChartOptions } from 'variables/charts';
import { fetchGPIDsLineBarChartData } from 'variables/charts';

export default function Conversion(props) {
  const { ...rest } = props;

  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const cardColor = useColorModeValue('white', 'navy.700');

  const [chartData, setChartData] = useState({});
  const [isLoading, setIsLoading] = useState(true);  // New loading state
  const [hasError, setHasError] = useState(false);   // New error state
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchDataAndUpdateState = async () => {
      try {
        setIsLoading(true);
        const newData = await fetchGPIDsLineBarChartData();
        setChartData(newData);
        setCategories(newData.samples);
        setIsLoading(false);
      } catch (error) {
        console.error('An error occurred while fetching data:', error);
        setHasError(true);
        setIsLoading(false);
      }
    };
    fetchDataAndUpdateState();
  }, []);

  const options = { // Dynamically set the options
    ...gpIDsLineBarChartOptions,
    xaxis: {
      categories: categories
    }
  };

  return (
    <Card p='20px' align='center' direction='column' w='100%' {...rest}>
      <Box mb='8px'>
        <Text color={textColor} fontSize='md' fontWeight='600' mt='4px'>
          Glycopeptide identifications
        </Text>
      </Box>
      <Box bg={cardColor} p='15px' w='100%'>
        {isLoading ? (
          <Text>Loading...</Text>
        ) : hasError ? (
          <Text>Error loading chart.</Text>
        ) : (
          <Chart
            options={options}
            series={chartData.series}
            height='300'
          />
        )}
      </Box>
    </Card>
  );
}
